module.exports = __webpack_public_path__ + "static/media/rgs_clinic_monitor.eab23aa9.png";